import lsg_buybox_rebuild from './sections/lsg-buybox-rebuild';
import lsg_press_hits from './sections/lsg-press-hits';
import lsg_header from './sections/lsg-header';
import lsg_carousel_rebuild from './sections/lsg-carousel-rebuild';

import './components/lsg-accordions';

(function() {

    lsg_buybox_rebuild.init();
    lsg_press_hits.init();
    lsg_header.init();
    lsg_carousel_rebuild.init();

})();